// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  serverHost: "https://tfiapi.apps.binus.ac.id",
  serverPort: "",
  prefix: "api",
  apiUrl: "https://tfiapi.apps.binus.ac.id/api",
  // Azure AD config
  clientId: "f9cfa6b3-839d-417e-9255-de2512bd7f99", // clientID
  authority:
    "https://login.microsoftonline.com/3485b963-82ba-4a6f-810f-b5cc226ff898", // tenantID
  redirectUri: "https://tfi.apps.binus.ac.id",
  postLogoutRedirectUri: "https://tfi.apps.binus.ac.id/login",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
